
import {
  PrescaleTblDiff,
} from '../../types'
import Vue, { PropType } from 'vue'
export default Vue.extend({
  name: 'PSDiffView',
  data() {
    return {      
      activeColumns : [] as Array<string>,
      selectAllCols : true as boolean
    }
  },
  components :{
  },
  methods: {
    getPrescale(col : string,collnames: Array<string>,prescales : Array<number>) : number | null{
      let index = collnames.findIndex((element) => element === col);
      if(index>=0){
        return prescales[index]
      }else{
        return null
      }
    },
    toggleActive(col : string){
      let indx = this.activeColumns.findIndex(x => x===col)      
      if(indx==-1){
        this.activeColumns.push(col)
      }else{
        this.activeColumns.splice(indx,1)
      }
    },
    selectClearCols(){
      if(this.selectAllCols===true){
        this.activeColumns = this.columns.slice()
      }else{
        this.activeColumns = []
      }
    },
    isActive(col : string){
      return this.activeColumns.includes(col)
    },
    nrDiffs(col : string){
      let nrDiffs = 0
      for( const path of this.psDiffs.path_ps_changes){
        var from_ps = this.getPrescale(col,this.psDiffs.colls_from,path.ps_from)
        var to_ps = this.getPrescale(col,this.psDiffs.colls_to,path.ps_to)          
        if(from_ps!=to_ps){
          nrDiffs++
        }
      }
      return nrDiffs
    },
    tableFormat(entry){
      if(entry[0]==entry[1]){
        return `<span class="black--text">${entry[0]}</span>`
      }else if(entry[0]==undefined){
        return `<span class="green--text">${entry[1]}</span>`
      }else if(entry[1]==undefined){
        return `<span class="red--text">${entry[0]}</span>`
      }else{
        return `<span class="orange--text">${entry[0]} -> ${entry[1]}</span>`
      }

    }
  },
  computed: {
    columns() : Array<string>{
      return [...this.psDiffs.colls_common,
              ...this.psDiffs.colls_added,
              ...this.psDiffs.colls_removed]
    },
    displayedColumns() : Array<string>{
      return this.columns.filter(x => this.activeColumns.includes(x))
    },
    indeterminateNrCols() : boolean {
      return this.activeColumns.length!==0 && this.activeColumns.length!==this.columns.length 
    },
    headers() {
      let headers = [{text:"path",value: "path"}]
      for( const col of this.displayedColumns){
        headers.push({text:col, value: col })
      }       
      return headers
    },
    paths(){
      //here we return an object with attributes for each column
      let paths : Array<any> = []      
      
      for( const path of this.psDiffs.path_ps_changes){
        let pathData :any = [["path",path.path]]
        var hasDiff = false
        for( const colname of this.displayedColumns) {   
          var from_ps = this.getPrescale(colname,this.psDiffs.colls_from,path.ps_from)
          var to_ps = this.getPrescale(colname,this.psDiffs.colls_to,path.ps_to)
          pathData.push([colname,[from_ps,to_ps]])
          if(from_ps!=to_ps){
            hasDiff = true
          }
        }        
        if(hasDiff){
          paths.push(
            Object.fromEntries(pathData)
          )
        }
      }      
      return paths
    },

  },
  props:{
    psDiffs : {type: Object as PropType<PrescaleTblDiff>, required: false } 
  },
  created(){
    
    this.activeColumns = this.columns.slice()
    
  },
  
})
